import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DropdownButton } from 'react-bootstrap';
import { MenuItem } from 'react-bootstrap';
import SpendingsActionCreator from '../../actions/SpendingsActionCreator';
import { AccountsModal } from './AccountsModal';

export default class SpendingsHeader extends PureComponent {
  static propTypes = {
    content: PropTypes.object,
    spendingAccountList: PropTypes.array,
    isNoBudget: PropTypes.bool,
    showAccountModal: PropTypes.bool,
    lastMonth: PropTypes.string,
    getAllAccountIds: PropTypes.array,
    loadSpendingPage: PropTypes.number,
  };
  state = {
    buttonTitle: null,
    lastMonth: moment(this.props.lastMonth).format('MMMM'),
    isCreateMessage: 'show',
    loadSpendingPage: this.props.loadSpendingPage,
  };
  componentDidMount() {
    if (this.props.loadSpendingPage === 2 || !this.props.isNoBudget) {
      this.setState({ buttonTitle: this.state.lastMonth });
    } else {
      this.setState({
        buttonTitle: this.props.content.spendingHeaderButtonLabel,
      });
    }
  }
  handleCreateBudget = () => {
    this.loadSpendingAction(3);
  };
  handleEditBudget = () => {
    this.loadSpendingAction(4);
  };
  hideCrateMessage = (e) => {
    e.preventDefault();
    this.setState({ isCreateMessage: 'hide' });
  };
  loadSpendingAction = (key) => {
    // Get Account List
    if (key === 4) {
      SpendingsActionCreator.getTagListConnection();
      if (!this.props.currentAccFlag) {
        SpendingsActionCreator.handlePotDataSpendings();
      } else {
        //* ** BOW-1192  POT ERROR SERVICE  IS BEEN CALLED FOR ONLY CURRENT ACC FOR EDIT SPENDINGS***
        SpendingsActionCreator.handlePotDataSpendingsError();
      }
    } else if (key === 3) {
      if (!this.props.currentAccFlag) {
        SpendingsActionCreator.handlePotDataSpendings();
      } else {
        //* ** BOW-1304  POT ERROR SERVICE  IS BEEN CALLED FOR ONLY CURRENT ACC FOR CREATE SPENDINGS***
        SpendingsActionCreator.handlePotDataSpendingsError();
      }
      SpendingsActionCreator.getSpendingPageWithKey(key);
    } else {
      SpendingsActionCreator.getTagListConnection();
      SpendingsActionCreator.getBudgetPreferencesConnection();
      SpendingsActionCreator.getAccountsList();
      SpendingsActionCreator.getSpendingPageWithKey(key);
    }
  };
  onButtonToggle(eventKey, e) {
    const key = parseInt(eventKey);
    this.loadSpendingAction(key);
    this.setState({ buttonTitle: e.target.innerHTML });
  }
  smClose = () => {
    SpendingsActionCreator.closeAccountModal();
  };
  smShow = () => {
    SpendingsActionCreator.getAllSelectedAccountNumnber();
  };
  render() {
    const { showAccountModal, content, isNoBudget } = this.props;
    return (
      <span>
        <div className="spendings-header">
          <div className="row no-gutters">
            <div className="col-xs-2 text-left">
              <a className="page-options opt-green" onClick={this.smShow}>
                {content.spendingAccountButtonLabel}
              </a>
            </div>
            <div className="col-xs-8 text-center">
              <h5>
                {content.spendingHeaderTitle}
                {isNoBudget ? (
                  <DropdownButton
                    title={this.state.buttonTitle}
                    noCaret
                    bsStyle="link"
                    id="spendngDropDown"
                    onSelect={this.onButtonToggle}
                  >
                    <MenuItem eventKey="1">
                      {content.spendingHeaderButtonLabel}
                    </MenuItem>
                    <MenuItem eventKey="2">{this.state.lastMonth}</MenuItem>
                  </DropdownButton>
                ) : (
                  <DropdownButton
                    title={this.state.buttonTitle}
                    noCaret
                    bsStyle="link"
                    id="spendngDropDown"
                    onSelect={this.onButtonToggle}
                  >
                    <MenuItem eventKey="3">
                      {content.spendingHeaderButtonLabel2}
                    </MenuItem>
                    <MenuItem eventKey="2">{this.state.lastMonth}</MenuItem>
                  </DropdownButton>
                )}
              </h5>
            </div>
            <div className="col-xs-2 text-right">
              {isNoBudget ? (
                <a
                  className="page-options opt-green"
                  type="button"
                  onClick={this.handleEditBudget}
                >
                  <span className="icon icon-edit" />
                  {content.spendingHeaderButtonLabel3}
                </a>
              ) : (
                <a
                  className="page-options opt-green"
                  type="button"
                  onClick={this.handleCreateBudget}
                >
                  <span className="icon icon-edit" />
                  {content.spendingHeaderButtonLabel2}
                </a>
              )}
            </div>
          </div>
        </div>
        {!isNoBudget && (
          <div className={`alert text-center ${this.state.isCreateMessage}`}>
            <div
              className="alert-container text-center"
              onClick={this.hideCrateMessage}
            >
              <a className="page-options icon icon-close" />
              <h6>{content.spendingHeaderNoBudgetWatning}</h6>
            </div>
          </div>
        )}
        {showAccountModal && (
          <AccountsModal
            getAllAccountIds={this.props.getAllAccountIds}
            content={content}
            onHide={this.smClose}
            spendingAccountList={this.props.spendingAccountList}
          />
        )}
      </span>
    );
  }
}
